import {Login} from "./Login";
import { Forget } from "./Forget";
import { Register } from "./Register";

export {Login , Forget , Register} ;